import Panel from 'components/shared/Panel/index';
import React from 'react';
import CouponAddPage from './CouponAddPage';
import { PANEL_TYPES } from '../utils/constants';
import CouponCodeDetail from '../components/detail/CouponCodeDetail';

const CouponDetailPage = () => {
  const panel = [
    {
      key: PANEL_TYPES.INFORMATION,
      label: 'Thông tin chung',
      noActions: true,
      component: CouponAddPage,
    },
    {
      key: PANEL_TYPES.LIST_COUPON,
      label: 'Danh sách mã',
      component: CouponCodeDetail,
    },
  ];
  return (
    <div className='bw_main_wrapp'>
      <Panel panes={panel} />
    </div>
  );
};

export default CouponDetailPage;
